export const NAV = {
  langSwitch: "language-switcher",
  langOption: (code) => `language-option-${code}`,
  loginBtn: "nav-login-btn",
  logoutBtn: "nav-logout-btn",
  dashboardBtn: "nav-dashboard-btn",
  navHome: "nav-home",
  navPortfolio: "nav-portfolio",
  navServices: "nav-services",
  navProcess: "nav-process",
  navAbout: "nav-about",
  navContact: "nav-contact",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  ctaPortfolio: "hero-cta-portfolio",
  ctaContact: "hero-cta-contact",
};

export const PORTFOLIO = {
  filter: (tag) => `portfolio-filter-${tag}`,
  card: (idx) => `portfolio-card-${idx}`,
  modal: "portfolio-modal",
  modalClose: "portfolio-modal-close",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  type: "contact-type",
  budget: "contact-budget",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const AUTH = {
  modal: "auth-modal",
  modalClose: "auth-modal-close",
  tabLogin: "auth-tab-login",
  tabRegister: "auth-tab-register",
  name: "auth-name",
  email: "auth-email",
  password: "auth-password",
  submit: "auth-submit",
  google: "auth-google-btn",
  error: "auth-error",
  switch: "auth-switch",
};

export const DASH = {
  tabProjects: "dash-tab-projects",
  tabBrief: "dash-tab-brief",
  tabFiles: "dash-tab-files",
  projectCard: (i) => `dash-project-${i}`,
  briefAnswer: (i) => `brief-answer-${i}`,
  briefSubmit: "brief-submit",
  briefSuccess: "brief-success",
};
